import moment from 'moment';

export const generateYears = () => {
  const currentYear = moment(new Date()).format('YYYY');
  let years = [];
  for (let i = 0; i < 12; i += 1) {
    years.push(String(Number(currentYear - i)));
  }
  return years;
};

export const generateYearsRange = () => {
  const currentYear = moment(new Date()).format('YYYY');
  let years = [];
  for (let i = 0; i < 12; i += 1) {
    years.push(String(Number(currentYear) + 5 - i));
  }
  return years.reverse();
};

export const lastYearDate = () => {
  const now = new Date();
  return {
    year: moment(now.setFullYear(now.getFullYear() - 1)).format('YYYY'),
    month: moment(now.setFullYear(now.getFullYear() - 1)).format('MM')
  };
};

export const getFullMonthName = month => {
  return moment(month, 'MM').format('MMMM');
};

export const getSmallMonthName = month => {
  return moment(month, 'MM').format('MMM');
};
